var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.7733,
    stroke: "#000",
    d: "M1.422 30.578l7.892-3.036c0.505-0.194 0.757-0.291 0.993-0.418 0.21-0.113 0.41-0.243 0.598-0.389 0.212-0.164 0.403-0.355 0.785-0.738l16.042-16.042c1.571-1.571 1.571-4.118 0-5.689s-4.118-1.571-5.689 0l-16.042 16.042c-0.382 0.382-0.574 0.574-0.738 0.785-0.146 0.188-0.276 0.388-0.388 0.598-0.127 0.236-0.224 0.489-0.418 0.994l-3.035 7.892zM1.422 30.578l2.927-7.61c0.209-0.545 0.314-0.817 0.494-0.942 0.157-0.109 0.351-0.15 0.539-0.114 0.215 0.041 0.421 0.247 0.834 0.66l3.213 3.213c0.413 0.413 0.619 0.619 0.66 0.834 0.036 0.188-0.005 0.382-0.114 0.539-0.125 0.18-0.397 0.284-0.942 0.494l-7.61 2.927z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8809ca0d1cd2057e7eea991ca811be5d.svg";
export { ForwardRef as ReactComponent };